import * as React from "react";
import { SessionExpiredDialog } from "lib/components/SessionExpiredDialog";
import { Notification } from "lib/components/Notification";
import style from "./style.module.css";
import { List } from "../List";
import { Detail } from "../Detail";
import { HorizontalSplitPane } from "lib/components/SplitPane";

export function App() {
  return (
    <div className={style.root}>
      <HorizontalSplitPane defaultRatio={0.5}>
        <div
          style={{
            borderRight: "1px solid #ccc",
            height: "100%",
            maxHeight: "100%",
            overflow: "auto",
          }}
        >
          <List />
        </div>
        <div style={{ height: "100%", maxHeight: "100%", overflow: "auto" }}>
          <Detail />
        </div>
      </HorizontalSplitPane>
      <SessionExpiredDialog />
      <Notification />
    </div>
  );
}
